import React from 'react'
import { Modal } from 'react-responsive-modal';
import { Input } from "@material-ui/core";
import {
  TitleProduct,
  SubTitleProduct,
  MiddleContainer,
  FormAsk
} from "./style/ConfirmOrderAskRoomLastNameModalStyle";

import { Flex } from "../../styles/GlobalStyle";
import ButtonComponent from "../Button";
import LoadingIcon from "../LoadingIcon";
import Property from "../../model/property"
import { makeStyles } from '@material-ui/core/styles';
import { withTranslation } from 'react-i18next';

const ConfirmOrderAskRoomLastNameModal = ({ showConfirmation, openCloseModal, onConfirm, total, loading, onChange, okDisabled, t }) => {
  const data = Property.getData()
  const autoText = data && data.store ? data.store.auto_reply_message : ""
  return (
    <Modal open={showConfirmation} onClose={() => openCloseModal(!showConfirmation)} showCloseIcon={false} center>
      <ModalContent onCancel={() => openCloseModal(!showConfirmation)}
        onConfirm={onConfirm} childrenTotal={total}
        children={t('CONFIRM_CONTENT')}
        autoReplyText={autoText}
        onChange={onChange}
        okDisabled={okDisabled}
        t={t}
      />
      <LoadingIcon loadingState={loading} />
    </Modal>
  )
}
const textInputStyles = makeStyles(() => ({
  resize: {
    fontSize: 14,
    lineHeight: 1,
    textAlign: 'center',
    padding: '20px 0 5px',
    caretColor: 'black'
  },
}));

export default withTranslation()(ConfirmOrderAskRoomLastNameModal)

function ModalContent({ onConfirm, onCancel, children, onChange, okDisabled, autoReplyText, t }) {
  const preset = Property.getPreset()
  const classes = textInputStyles()
  const submit = event => {
    event.preventDefault();
  };
  return (
    <MiddleContainer>
      <form
        onSubmit={submit}
      >
        <Flex flex={1} justifyContent={"center"}>
          <TitleProduct className={'modalTitle'}>{t('CONFIRM_ORDER')}</ TitleProduct>
          <hr />
          <SubTitleProduct className={'modalSubtitle'}>{children}</SubTitleProduct>
          <FormAsk style={{ marginBottom: '30px' }}>
            <Input placeholder={t('ROOM_NUMBER')}
              fullWidth
              classes={{ input: classes.resize }}
              inputProps={{ 'aria-label': 'description' }}
              onChange={(e) => onChange('roomNumber', e.target.value)}
              required />
            <Input placeholder={t('LAST_NAME')}
              fullWidth
              classes={{ input: classes.resize }}
              inputProps={{ 'aria-label': 'description' }}
              onChange={(e) => onChange('lastName', e.target.value)}
              required />
          </FormAsk>
          <Flex container flex={1} alignItems={"center"} justifyContent={"center"}>
            <ButtonComponent padding={"0.25em 0"} width={"80%"} label={t('OK')} backgroundColor={preset.app_home_color_primary ? preset.app_home_color_primary : "black"} color={preset.text_color} borderRadius={"30px"} onClick={onConfirm} disabled={okDisabled} />
          </Flex>
          <Flex container flex={1} alignItems={"center"} justifyContent={"center"}>
            <ButtonComponent padding={"0.25em 0"} width={"80%"} label={t('CANCEL')} backgroundColor={preset.app_home_color_primary ? preset.app_home_color_primary : "black"} color={preset.text_color} borderRadius={"30px"} onClick={onCancel} />
          </Flex>
        </Flex>
      </form>
    </MiddleContainer>
  )
}
